/* eslint-disable @typescript-eslint/no-explicit-any */

import { PostPaymentRequestBody, PostPaymentResponse } from "@/types/payments";

export default interface UsePostPaymentUseCase {
  postPayment: (postBody: PostPaymentRequestBody) => Promise<any>;
}

export const usePostPaymentService = (): UsePostPaymentUseCase => {
  const postPayment = async (postBody: PostPaymentRequestBody): Promise<PostPaymentResponse> => {
    const body: PostPaymentRequestBody = { ...postBody };

    const postPayment = await fetch("/api/post-payment", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });

    return await postPayment.json();
  };

  return { postPayment };
};
